// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 130 ? "photoEditor" : chunkId) + "-legacy." + {"130":"e85200ba","155":"b06b9fee","893":"4b2bb2be","912":"f298ab43"}[chunkId] + ".js";
};